import { useCookies } from 'react-cookie'

export const useCurrentUser2 = () => {
  const [cookies, setCookie, removeCookie] = useCookies(['user'])
return cookies.user
}
